jQuery_T4NT(document).ready(function($) {

  $(".kshm_grid_item_span_full").on("click", "video", function() {
        var video = $(this);
        var volume = video.parent().children(".volume-button");
        // Prevent event from firing twice when clicking both the video and the button
        if (video.prop('muted')) {
            video.prop('muted', false);
            volume.children("img.on").removeClass('d-none');
            volume.children("img.off").addClass('d-none');
        } else {
            video.prop('muted', true);
            volume.children("img.on").addClass('d-none');
            volume.children("img.off").removeClass('d-none');
        }
    });

  $(".view-all-faq").click(function() {
      var has = $(".more-faq").hasClass("active");
      if(!has){
          $(this).addClass("rotate");
        $("#view-all-text").text("View Less");
          $(".more-faq").addClass("active");
      }else{
          $(this).removeClass("rotate");
          $("#view-all-text").text("View All");
          $(".more-faq").removeClass("active");
      }
  })

  if(document.getElementById("product-detail-community-slider")){
     let inital = 20;
        document.getElementById("product-detail-community-slider").onscroll = function () { myFunction("product-detail-community-slider", `product-detail-community-slider-bar`) }

        function myFunction(val, bar) {
            let el = document.getElementById(val);
            var winScroll = el.scrollLeft || el.scrollLeft;
            var height = el.scrollWidth - el.clientWidth;
            var scrolled = (((winScroll / height) * 100)) * (inital * 0.040) + inital;
            document.getElementById(bar).style.width = scrolled + "%";
        }
    }

  $(".is-t4s-style__color").on("click",".t4s-swatch__item",function(){
    var color = $(this).data("value");
    $("#sticky-color").text(color);
    var count = $(".promo-box-mobile");
    var selColor = $(".promo-box-mobile[data-color='"+color+"']");
    if(count.length > 1){
      if (selColor.length > 0){
        $(".promo-box-mobile").attr("style", "display: none !important");
        selColor.css('display', '');
        $('#global-promo-box-mobile').attr("style", "display: none !important");
      }else{
        $(".promo-box-mobile").attr("style", "display: none !important");
        $("#global-promo-box-mobile").css('display', '');
      }
    }
  });
  $(".is-t4s-name__size").on("click",".t4s-swatch__item",function(){
    var size = $(this).data("value");
    $("#sticky-size").text(size)
  });

//   $(window).scroll(function() {
//     $('video:not(".not-scroll-play")').each(function() {
//         if(isInView(this)) {
//             this.play();
//         } else {
//             this.pause();
//         }
//     });
// });

  $('body').on('click touchstart', function () {
    $('video:not(".not-scroll-play")').each(function() {
        if(this.paused) {
            this.play();
        }
    });
  });

  function isInView(el) {
    windowTop = $(window).scrollTop();
    windowButtom = windowTop + $(window).height();
    elTop = $(el).offset().top;
    elButtom = elTop + $(el).height();

    return (elTop >= windowTop && elButtom <= windowButtom);
}
   // $('body').on('click touchstart', function () {
   //      const videoElement = document.getElementById('gifdesc1');
   //      const videoElement2 = document.getElementById('gifdesc2');
   //      const videoElement3 = document.getElementById('gifdesc3');
   //      if(videoElement && videoElement2){
   //          if (videoElement.playing) {} else { videoElement.play();}
   //          if (videoElement2.playing) {} else { videoElement2.play();}
   //      }
   //      if(videoElement3){
   //          if (videoElement3.playing) {} else { videoElement3.play();}
   //      }
   //  });

// unique designs slider js start

// var lightbox = new PhotoSwipeLightbox({
//   gallery: '.kshm_AOTI_Gallery',
//   children: 'a',
//   // dynamic import is not supported in UMD version
//   pswpModule: PhotoSwipe
// });
// lightbox.init();

// $('.khsm_UniqDesignsSlider').slick({
//     dots: true,
//     arrows: true,
//     infinite: false,
//     speed: 400,
//     fade:false,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     responsive: [{
//             breakpoint: 1024,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 arrows: true,
//                 infinite: false,
//             }
//         },

//         {
//             breakpoint: 600,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 arrows: true,
//                 infinite: false,
//             }
//         },
//         {
//             breakpoint: 480,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 arrows: true,
//                 infinite: false,
//             }
//         }
//     ]
// });

// unique designs slider js end

// CBA slider js start

// $('.kshm_CBAMainSlider').slick({
//     dots: true,
//     arrows: true,
//     infinite: false,
//     speed: 400,
//     fade:false,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     responsive: [{
//             breakpoint: 1024,
//             settings: {
//                 slidesToShow: 3,
//                 slidesToScroll: 1,
//                 arrows: false,
//                 infinite: false,
//             }
//         },

//         {
//             breakpoint: 600,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 arrows: false,
//                 infinite: false,
//             }
//         },
//         {
//             breakpoint: 480,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 arrows: false,
//                 infinite: false,
//             }
//         }
//     ]
// });

// CBA slider js end
// const countDate = $("#countdown-date").val()
// const countDownToTime = new Date(countDate).getTime();
// const timeNow = new Date().getTime();
// if (timeNow < countDownToTime) {
//   console.log("Here");
//   setInterval(startTimer, 1000);
// }
// function startTimer() {
//   const timeNow = new Date().getTime();
//   const timeDifference = countDownToTime - timeNow;
//   const millisecondsInOneSecond = 1000;
//   const millisecondsInOneMinute = millisecondsInOneSecond * 60;
//   const millisecondsInOneHour = millisecondsInOneMinute * 60;
//   const millisecondsInOneDay = millisecondsInOneHour * 24;
//   const differenceInDays = timeDifference / millisecondsInOneDay;
//   const remainderDifferenceInHours = (timeDifference % millisecondsInOneDay) / millisecondsInOneHour;
//   const remainderDifferenceInMinutes = (timeDifference % millisecondsInOneHour) / millisecondsInOneMinute;
//   const remainderDifferenceInSeconds = (timeDifference % millisecondsInOneMinute) / millisecondsInOneSecond;
//   const remainingDays = Math.floor(differenceInDays);
//   const remainingHours = Math.floor(remainderDifferenceInHours);
//   const remainingMinutes = Math.floor(remainderDifferenceInMinutes);
//   const remainingSeconds = Math.floor(remainderDifferenceInSeconds);
//   $("#discount-count-timer").removeClass("d-none")
//   document.getElementById("discount-count-timer").innerHTML = ((remainingDays > 0 ?(remainingDays + "<span> days</span>" + " "):"") + remainingHours + "<span> hours</span>" + " " + remainingMinutes + "<span> min</span>" + " " + (remainingDays <= 0 ?(remainingSeconds + "<span> sec</span>" + " "):""));
// }

function fn_copy(copyText) {
    // Copy the text inside the text field
    navigator.clipboard.writeText(copyText);

    // Alert the copied text
    alert("Copied to clipboard");
}

// companies slider js start

// $('.kshm_companiesSlider').slick({
//     dots: false,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     pauseOnHover: false,
//     arrows: false,
//     infinite: true,
//     speed: 400,
//     fade:false,
//     slidesToShow: 3,
//     // slidesToScroll: 1,
//     // responsive: [{
//     //         breakpoint: 1024,
//     //         settings: {
//     //             slidesToShow: 6,
//     //             slidesToScroll: 1,
//     //             arrows: false,
//     //             infinite: true,
//     //         }
//     //     },

//     //     {
//     //         breakpoint: 600,
//     //         settings: {
//     //             slidesToShow: 4,
//     //             slidesToScroll: 1,
//     //             arrows: false,
//     //             infinite: true,
//     //         }
//     //     },
//     //     {
//     //         breakpoint: 480,
//     //         settings: {
//     //             slidesToShow: 4,
//     //             slidesToScroll: 1,
//     //             arrows: false,
//     //             infinite: true,
//     //         }
//     //     }
//     // ]
// });

// companies slider js end

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });


var firstItem = $('.t4s-swatch__list .t4s-swatch__item[data-value="XS"]');
var lastItem = $('.kshm_size[data-value="Custom Size"]');

$(lastItem).magnificPopup({
  items: {
      src: '.kshm_orderpopup',
      type: 'inline'
  },
  callbacks: {
    close: function(){
       var length = $("#length_cm").val();
        var waist = $("#waist_cm").val();
       if(length == "" && waist == ""){
         firstItem.trigger("click");
          return true;
       }
    }
  }
});

$("#view_all_coupon").magnificPopup({
  items: {
      src: '#coupon_summary',
      type: 'inline'
  },
  // Class that is added to popup wrapper and background
  // make it unique to apply your CSS animations just to this exact popup
  mainClass: 'mfp-fade mfp-coupon'
});

$(".faq_cta").magnificPopup({
  items: {
      src: '#contact-form',
      type: 'inline'
  },
  // Class that is added to popup wrapper and background
  // make it unique to apply your CSS animations just to this exact popup
  mainClass: 'mfp-fade'
});

  $("#coupon_close_button").click(function() {
    $("#coupon_summary").magnificPopup("close");
  })
  
  $("#contact-form .close-btn").click(function() {
    $("#contact-form").magnificPopup("close");
  });
 
if(typeof contactFormPosted !== 'undefined' && contactFormPosted == true){
  console.log(contactFormPosted);
  $.magnificPopup.open({
    items: {
      src: '#success-contact-form',
      type: 'inline'
    },
    mainClass: 'mfp-fade'
    // You may add options here, they're exactly the same as for $.fn.magnificPopup call
    // Note that some settings that rely on click event (like disableOn or midClick) will not work here
  }, 0);
  setTimeout(() => $("#contact-form").magnificPopup("close"),3000);
}

$(".kshm_orderpopupCloseIcon").on('click', function(e) {
    var length = $("#length_cm").val("");
    var waist = $("#waist_cm").val("");
     firstItem.trigger("click");
});

  $("#length_cm").keyup(function() {
    $(this).removeAttr("style");
    $(".kshm_orderpopupOrderSize p").remove();
  });
  $("#waist_cm").keyup(function() {
    $(this).removeAttr("style");
    $(".kshm_orderpopupOrderSize p").remove();
  });

$(".continue-order").on('click', function(e) {
  e.preventDefault();
  var length = $("#length_cm");
  var waist = $("#waist_cm");
  if(length.val() == null && waist.val() == null){
    length.css("border","1px solid #d28888");
    waist.css("border","1px solid #d28888");
    $(".kshm_orderpopupOrderSize").remove("p");
    $(".kshm_orderpopupOrderSize").prepend("<p>Please select Length and Waist</p>");
    return;
  }
  if(length.val() == null){
    length.css("border","1px solid #d28888");
    $(".kshm_orderpopupOrderSize p").remove("p");
    $(".kshm_orderpopupOrderSize").prepend("<p>Please select Length</p>");
    return;
  }
  if(waist.val() == null){
    waist.css("border","1px solid #d28888");
    $(".kshm_orderpopupOrderSize p").remove("p");
    $(".kshm_orderpopupOrderSize").prepend("<p>Please select Waist</p>");
    return;
  }
  $.magnificPopup.close();
  // $(".s-title .t4s-dib").text(length.val()+"x"+waist.val());
  $(".kshm_product_size_text strong").text(length.val()+'" x '+waist.val()+'"');
});

$("body").on("click", ".mfp-cl", function() {
      $(".mobile-menu-section").removeClass("animate");   
      // setTimeout(() => {
      // },250);
      setTimeout(() => {
        $(".mobile-menu-section").removeClass("opened");
         $('.m-menu-drawer').magnificPopup('close');
      },450);
});

$('.m-menu-drawer').magnificPopup({
  modal:true,
  showCloseBtn:false,
  mainClass: 'mfp-menu-mobile',
  callbacks: {
    open: function() {
      $("body").css('overflow', "hidden");
      $(".mobile-menu-section").addClass("opened");
      setTimeout(() => {
        $(".mobile-menu-section").addClass("animate");
        // $(".mobile-menu-header").addClass("visible-m");
        // $(".image-banner").addClass("visible-m");
        // $(".product-section").addClass("visible-m");
        // $(".featured-product-section").addClass("visible-m");
        // $(".contact-section").addClass("visible-m");
        // $(".mobile-menu-header").removeClass("not-visible-m");
        // $(".image-banner").removeClass("not-visible-m");
        // $(".product-section").removeClass("not-visible-m");
        // $(".featured-product-section").removeClass("not-visible-m");
        // $(".contact-section").removeClass("not-visible-m");
      },130)
    },
    beforeClose: function() {
        $("body").css('overflow', "auto");
        $(".mobile-menu-section").removeClass("opened");
        $(".mobile-menu-section").removeClass("animate");
        //  $(".mobile-menu-header").addClass("not-visible-m");
        // $(".image-banner").addClass("not-visible-m");
        // $(".product-section").addClass("not-visible-m");
        // $(".featured-product-section").addClass("not-visible-m");
        // $(".contact-section").addClass("not-visible-m");

        // $(".mobile-menu-header").removeClass("visible-m");
        // $(".image-banner").removeClass("visible-m");
        // $(".product-section").removeClass("visible-m");
        // $(".featured-product-section").removeClass("visible-m");
        // $(".contact-section").removeClass("visible-m");
    },
  },
  items: {
      src: '.mobile-menu-section',
      type: 'inline'
  }
});


// $('.owl-carousel').owlCarousel({
//         items:1,
//         merge:false,
//         loop:false,
//         margin:10,
//         video:true,
//         center:false,
//         autoWidth:true,
//         responsive:{
//             480:{
//                 items:2
//             },
//             600:{
//                 items:4
//             }
//         }
//     });



  //custom Accordion
  // Smooth scrolling effect
            $(".close-icon").on('click', function(event) {
                event.preventDefault();

                var target = $(this).closest('.pd-list');
                $('#shopify-section-template--21337806340386__65e4c32b-b9a7-4cf0-8ac4-dd7de2bc9c11').animate({
                    scrollTop: target.offset().top
                }, 100);
            });

            // Toggle functionality
            $('.pd-list').each(function(index) {
                if (index === $('.pd-list').length - 1) {
                    // Expand the last one by default and add active class
                    $(this).find('.info').slideDown();
                    $(this).find('.close-icon .icon-plus').css('opacity', '0');
                    $(this).find('.close-icon .icon-minus').css('opacity', '1');
                    $(this).addClass('active');
                }
            });

            $('.heading').click(function () {
                //var $pdList = $(this).closest('.pd-list');
                //var $info = $pdList.find('.info');

                // Use stop() to prevent animation queue buildup
                

              var $pdList = $(this).closest('.pd-list');
                $pdList.find('.info').slideToggle(200);
                $pdList.siblings('.pd-list').find('.info').slideUp(100);

                $pdList.siblings('.pd-list').find('.close-icon .icon-plus').css('opacity', '1');
                $pdList.siblings('.pd-list').find('.close-icon .icon-minus').css('opacity', '0');
                $pdList.siblings('.pd-list').removeClass('active');

                // Update the icon opacity for the clicked item
                var $iconPlus = $(this).find('.icon-plus');
                var $iconMinus = $(this).find('.icon-minus');
                $iconPlus.css('opacity', $iconPlus.css('opacity') === '1' ? '0' : '1');
                $iconMinus.css('opacity', $iconMinus.css('opacity') === '1' ? '0' : '1');

                // Add active class to the clicked item
                $pdList.toggleClass('active');
            });
  //custom accordion

  //alert('Hello');
  //// Moving ////
  // $('#shopify-prices').appendTo('#price-container');
  // $('<span class="incl-all-tax">Inclusive of taxes</span>').appendTo('#price-container');
  // $('.t4s-badge-price').css('text-transform', 'capitalize');
  // $('.t4s-badge-price').css('display', 'none');
  // var currentContent = $('.t4s-badge-item.t4s-badge-sale').text();
  //$('.t4s-badge-item.t4s-badge-sale').text(currentContent + ' Off');
  // span before t4s-badge-price
  // $('<span class="t4s-badge-price-before"></span> <span id="percentage-off-container"></span>').insertBefore('.t4s-badge-price');
  // if ($(window).width() > 768) {
  //   $('.col-sm-8').appendTo('.his-her-row');
  // }

// Get the original and sale prices
  // $('.t4s-product-price del').html("<span class='currency'>₹</span>"+$('.t4s-product-price del').text().replace('₹', ''))
  // $('.t4s-product-price ins').html("<span class='currency'>₹</span>"+$('.t4s-product-price ins').text().replace('₹', ''))
  // var originalPrice = parseFloat($('.t4s-product-price del').text().replace('₹', ''));
  // var salePrice = parseFloat($('.t4s-product-price ins').text().replace('₹', ''));

  // // Calculate the percentage off
  // var percentageOff = Math.round(((originalPrice - salePrice) / originalPrice) * 100);

  // Display the calculated percentage in the container
  // $('#percentage-off-container').text(+ percentageOff.toFixed(2) + '% OFF');

// Get the original and sale prices

$('#shopify-section-template--21337806340386__a0f62a9a-2be8-4ad5-8477-02f798c45eea').appendTo('#my-custom-content');

  //move breadcrumb
  
  var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  if(screenWidth >767){
    $('#shopify-section-template--21337806340386__breadcrumb').appendTo('.product-breadcrumb-container');
    $('#shopify-section-template--22017181253922__breadcrumb').appendTo('.product-breadcrumb-container');
    $('#shopify-section-template--22016744882466__breadcrumb').appendTo('.product-breadcrumb-container');
    $('.product-breadcrumb-container #shopify-section-template--21337806340386__breadcrumb').show();
    $('.product-breadcrumb-container #shopify-section-template--22017181253922__breadcrumb').show();
    $('.product-breadcrumb-container #shopify-section-template--22016744882466__breadcrumb').show();
  }

  // if(screenWidth <767){
  //   $('.t4s-product__info-main .product-name').insertBefore('.breadcrumb_pr_wrap .t4s-container > .t4s-row.t4s-align-items-center');
  //   $('.t4s-product__description').hide();

  //   $('.our-sizes').insertBefore('.t4s-swatch__option.is-t4s-name__size');
  // }

  //JavaScript to toggle visibility based on screen width
  function handleVisibility() {
      // Get the screen width
      var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

      // Check if it's a mobile screen (less than or equal to 767px)
      if (screenWidth <= 767) {
        // $('.desktop-only').remove(); // Remove the desktop container
        //$('.mobile-menu-section').clone().appendTo('#t4s-menu-drawer');
      } else {
        $("#review-pill").attr("href", "#section-product-rating-and-reivew");
        // $('.mobile-only').remove(); // Remove the mobile container
      }
    }

    // Initial visibility check
    handleVisibility();

    // Update visibility on window resize
    $(window).resize(function() {
      handleVisibility();
    });

  //JavaScript to play the MP4 on scroll (mobile only)

  var mainVideo = $('#logo-kshm-video-main');
  var reverseVideo = $('#logo-kshm-video-reverse');
  var playLogo = $('#play-logo');
  var defaultMobileLogo = $('.header__sticky-logo.t4s-d-none, .header__mobile-logo.t4s-d-lg-none');
  var scrollThresholdMain = 600;
  var scrollThresholdReverse = 1; // Adjust this threshold as needed
  var hasPlayedMain = false;

  // Function to play the main video once
  function playMainVideoOnce() {
    if (!hasPlayedMain) {
      mainVideo[0].play().catch(function(error) {
        // Autoplay failed, handle error
      });
      reverseVideo[0].pause();
      hasPlayedMain = true;
    }
  }

  // Function to play the reverse video once
  function playReverseVideoOnce() {
    mainVideo[0].pause();
    reverseVideo[0].play().catch(function(error) {
      // Autoplay failed, handle error
    });
  }

  // Function to show/hide videos based on scroll position
  function checkVideoVisibility() {
    var scrollPosition = $(window).scrollTop();
    var screenWidth = $(window).width();
    // Check if on mobile (screen width less than 768px)
    if (screenWidth < 768) {
      if (scrollPosition >= scrollThresholdMain && !hasPlayedMain) {
        // Scroll down: Show main video, hide reverse video
        playMainVideoOnce();
        mainVideo.removeClass('invisible');
        reverseVideo.addClass('invisible');
        defaultMobileLogo.addClass('invisible');
        return;
      } else if (scrollPosition <= scrollThresholdReverse) {
        // Scroll back to top: Show reverse video, hide main video
        playReverseVideoOnce();
        mainVideo.addClass('invisible');
        reverseVideo.removeClass('invisible');
        defaultMobileLogo.addClass('invisible');
        hasPlayedMain = false; // Reset the flag for the next scroll down
        return;
      }
      return;
    }
  }

  // Event listener for user interaction
  // playLogo.on('click', function() {
  //   //playMainVideoOnce();
  // });

  // Check on scroll
  // $(window).scroll(function() {
  //   checkVideoVisibility();
  // });

  var jqToast = (function ($) {
  // create the container if it doesn't exist
  var $toastContainer = $('.toast-container');
  if ($toastContainer.length === 0) {
    $('body').append($('<div>').addClass('toast-container'));
  }
  
  var getOptions = function (opts) {
    return $.extend({},
    {
      displayTime: 3000,
      fadeTime: 1750,
      text: ''
    },
    opts);
  };
  
  var closeToast = function ($toast, fadeTime) {
    // Add the fading class and remove the 'click' binding
    $toast
      .addClass('fading')
      .off('click');
    
    // Fade the toast message out and remove it
    $toast.fadeOut(fadeTime, function () {
      //$toast.remove();
    });
  }
  
  var addToast = function (type, options) {
    var iconName = '';
    // Determine icon type
    switch (type) {
      case 'success':
        iconName = 'fa-check';
        break;
      case 'error':
        iconName = 'fa-times';
        break;
    }
    
    // Build the icon element
    var $icon = $('<div>').addClass('icon').append($('<i>').addClass('fa ' + iconName));
    
    // Build the toast message and add it to the container
    var $toast = $('<div>')
      .addClass('toast ' + type + " show")
      // .append($icon)
      .append($('<div>').addClass('text').text(options.text));
    
    $('.toast-container').append($toast);
    
    // Close the toast message
    $toast.on('click', function () {
      closeToast($toast, options.fadeTime);
    });
    
    // Automatic fade
    setTimeout(function () {
      closeToast($toast, options.fadeTime);
    }, options.displayTime);
  }
  
  var successToast = function (opts) {
    var options = getOptions(opts);
    addToast('success', options);
  }
  
  var errorToast = function (opts) {
    var options = getOptions(opts);
    addToast('error', options);
  }
  
  return {
    success: function (opts) {
      successToast(opts);
    },
    error: function (opts) {
      errorToast(opts);
    }
  }
})(jQuery_T4NT);

$(document).ready(function () {
  $('.copy-coupon').on('click', function () {
    var coupon = $(this).data('coupon');
    navigator.clipboard.writeText(coupon);
    $(this).closest(".kshm_coupon").addClass("active");
    $(this).closest(".kshm_coupon").find(".coupon-m-text").text("Coupon copied!");
    // var toastMethod = jqToast.success;
    
    // toastMethod({
    //   displayTime: 2000,
    //   fadeTime: 1500,
    //   text: "Coupon copied: "+coupon
    // });
  });
  
  $('.apply_coupon_modal').on('click', function () {
    var coupon = $(this).data('code');
    navigator.clipboard.writeText(coupon);
    $(".apply_coupon_modal").each(function(e) {
      $(this).removeClass('active');
      $(this).find('span').text($(this).data('code'));
    });
    $(this).addClass("active");
    $(this).find("span").text("Copied!");
    // var toastMethod = jqToast.success;
    
    // toastMethod({
    //   displayTime: 2000,
    //   fadeTime: 1500,
    //   text: "Coupon copied: "+coupon
    // });
  });
});



});

/**
 * Human readable elapsed or remaining time (example: 3 minutes ago)
 * @param  {Date|Number|String} date A Date object, timestamp or string parsable with Date.parse()
 * @param  {Date|Number|String} [nowDate] A Date object, timestamp or string parsable with Date.parse()
 * @param  {Intl.RelativeTimeFormat} [trf] A Intl formater
 * @return {string} Human readable elapsed or remaining time
 * @author github.com/victornpb
 * @see https://stackoverflow.com/a/67338038/938822
 */
function fromNow(date, nowDate = Date.now(), rft = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" })) {
    const SECOND = 1000;
    const MINUTE = 60 * SECOND;
    const HOUR = 60 * MINUTE;
    const DAY = 24 * HOUR;
    const WEEK = 7 * DAY;
    const YEAR = 365 * DAY;
    const MONTH = YEAR / 12;
    const intervals = [
        { ge: YEAR, divisor: YEAR, unit: 'year' },
        { ge: MONTH, divisor: MONTH, unit: 'month' },
        { ge: WEEK, divisor: WEEK, unit: 'week' },
        { ge: DAY, divisor: DAY, unit: 'day' },
        { ge: HOUR, divisor: HOUR, unit: 'hour' },
        { ge: MINUTE, divisor: MINUTE, unit: 'minute' },
        { ge: 30 * SECOND, divisor: SECOND, unit: 'seconds' },
        { ge: 0, divisor: 1, text: 'just now' },
    ];
    const now = typeof nowDate === 'object' ? nowDate.getTime() : new Date(nowDate).getTime();
    const diff = now - (typeof date === 'object' ? date : new Date(date)).getTime();
    const diffAbs = Math.abs(diff);
    for (const interval of intervals) {
        if (diffAbs >= interval.ge) {
            const x = Math.round(Math.abs(diff) / interval.divisor);
            const isFuture = diff < 0;
            return interval.unit ? rft.format(isFuture ? x : -x, interval.unit) : interval.text;
        }
    }
}


//Reviews

let productId = $("#productId").val();  // Replace with your product ID
let reviewUrl = $("#reviewUrl").val();  // Replace with your product ID
let minRating = null;  // Replace with your minimum rating
let pagination_limit = 10;  // Replace with your pagination limit
let page = 1;  // Replace with your page number


// let url = `https://stamped.io/api/widget/badges?isIncludeBreakdown=true&isincludehtml=false`;

// fetch(url, {
//     method: 'POST',
//     body: JSON.stringify({"productIds":[{"productId":productId}],"apiKey":"pubkey-5pZR485u3E8Hhe70Pv7O1tN9ZyT75r","storeUrl":"262003"}),
//     headers: {
//         'Content-Type': 'application/json',
//     }
// })
// .then(response => response.json())
// .then(data => {
//   $("#section-product-rating-and-reivew-mobile .rating-left .rating-point").text(Math.round(data[0].rating * 10)/10);
//   $("#section-product-rating-and-reivew-mobile .rating-left .rating-text").text("Review ("+data[0].count+")");
//   $("#section-product-rating-and-reivew .rating-left .rating-point").text(Math.round(data[0].rating * 10)/10);
//   $("#section-product-rating-and-reivew .rating-left .rating-text").text("Review ("+data[0].count+")");
  
//   // $("#review-pill .rating .btn-rating").html(`${Math.round(data[0].rating * 10)/10}<span>(${data[0].count})</span>`);
//   // $("#review-main").html(`<span>${Math.round(data[0].rating * 10)/10} </span>(${data[0].count})`);
//   var html = "";
//   for (key in data[0].breakdown){
//     html += '<div class="rating-star rating-star-5"><h2 class="rating-point">'+key.replace("rating","")+'</h2><div class="star"><svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg"><path d="M7.44344 0.886841L9.22011 5.99808L14.6302 6.10833L10.3181 9.37749L11.8851 14.5569L7.44344 11.4661L3.00178 14.5569L4.56874 9.37749L0.256687 6.10833L5.66678 5.99808L7.44344 0.886841Z"></path></svg></div><div class="rating-percentage"><div class="progress" style="width: '+ ((data[0].breakdown[key]/data[0].count)*100) +'%"></div></div><span class="value">('+data[0].breakdown[key]+')</span></div>'
//   }
//   $("#section-product-rating-and-reivew-mobile .rating-right .rating-filter.flex-column-reverse").html(html);
//   $("#section-product-rating-and-reivew .rating-right .rating-filter.flex-column-reverse").html(html);
// })
// .catch(error => {
//     console.error('Error:', error);
// });

//Reviews List

let urld = reviewUrl;
let reviewsData = [];

// fetch(urld, {
//     method: 'GET',
//     headers: {
//         'Content-Type': 'application/json',
//        'Cache-Control': 'no-cache, no-store, must-revalidate', 
//        'Pragma': 'no-cache', 
//        'Expires': '0'
//     }
// })
// .then(response => response.json())
// .then(data => {
//   reviewsData = data.results
//   showReviews(page);
// })
// .catch(error => {
//     console.error('Error:', error);
// });

function showReviews(currentPage) {
  page = currentPage;
  const paginateArray =  (array, pageNumber, pageSize) => {
    const page = array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
    return page;
  };
  var newArray = paginateArray(reviewsData, currentPage, pagination_limit);
  var html = "";
  var pagination = "";
  $("#section-product-rating-and-reivew-mobile .container .review-stamped").remove();
  $("#section-product-rating-and-reivew-mobile .container .pagination-container").remove();
  $("#section-product-rating-and-reivew .container .pagination-container").remove();
  $("#section-product-rating-and-reivew .container .review-stamped").remove();
  for(key in newArray) {
    html += '<div class="row review-stamped"><div class="col-sm-3 reviewer-info"><div class="reviewer"><div class="image">'+newArray[key].review.author.match(/\b(\w)/g).join('')+'</div><div class="review-meta"><div class="name">'+newArray[key].review.author+' <div class="svg '+(newArray[key].review.verifiedType <= 0 ? 'd-none':'')+'" ><svg xmlns="http://www.w3.org/2000/svg" width="16.002" height="16" viewBox="0 0 16.002 16"><path data-name="Path 1" d="M113.894 37a2.667 2.667 0 0 1 0-2.026l.089-.213a2.674 2.674 0 0 0-1.44-3.484l-.2-.089a2.6 2.6 0 0 1-1.44-1.44l-.071-.178a2.709 2.709 0 0 0-3.5-1.44l-.178.071a2.712 2.712 0 0 1-2.044 0l-.16-.071a2.683 2.683 0 0 0-3.466 1.457l-.071.142a2.6 2.6 0 0 1-1.44 1.44l-.16.071a2.681 2.681 0 0 0-1.413 3.487l.071.16a2.667 2.667 0 0 1 0 2.026l-.071.2a2.633 2.633 0 0 0 1.44 3.466l.178.071a2.6 2.6 0 0 1 1.44 1.44l.089.2a2.656 2.656 0 0 0 3.466 1.457l.2-.089a2.712 2.712 0 0 1 2.044 0l.16.071a2.674 2.674 0 0 0 3.484-1.44l.071-.142a2.6 2.6 0 0 1 1.44-1.44l.142-.053a2.653 2.653 0 0 0 1.44-3.484zm-8.46 2.4-3.466-2.915 1.066-1.262 2.2 1.866 3.892-4.621 1.262 1.066z" transform="translate(-98.188 -27.935)" style="fill: rgb(0, 165, 167);"></path></svg></div></div><div class="verified-text"> Verified by Stamped.io </div></div></div></div><div class="col-sm-9"><div class="reivew"><div class="star-and-time"><div class="star"><span class="active"><svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg"><path d="M7.44344 0.886841L9.22011 5.99808L14.6302 6.10833L10.3181 9.37749L11.8851 14.5569L7.44344 11.4661L3.00178 14.5569L4.56874 9.37749L0.256687 6.10833L5.66678 5.99808L7.44344 0.886841Z"></path></svg></span><span class="active"><svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg"><path d="M7.44344 0.886841L9.22011 5.99808L14.6302 6.10833L10.3181 9.37749L11.8851 14.5569L7.44344 11.4661L3.00178 14.5569L4.56874 9.37749L0.256687 6.10833L5.66678 5.99808L7.44344 0.886841Z"></path></svg></span><span class="active"><svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg"><path d="M7.44344 0.886841L9.22011 5.99808L14.6302 6.10833L10.3181 9.37749L11.8851 14.5569L7.44344 11.4661L3.00178 14.5569L4.56874 9.37749L0.256687 6.10833L5.66678 5.99808L7.44344 0.886841Z"></path></svg></span><span class="active"><svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg"><path d="M7.44344 0.886841L9.22011 5.99808L14.6302 6.10833L10.3181 9.37749L11.8851 14.5569L7.44344 11.4661L3.00178 14.5569L4.56874 9.37749L0.256687 6.10833L5.66678 5.99808L7.44344 0.886841Z"></path></svg></span><span class="active"><svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg"><path d="M7.44344 0.886841L9.22011 5.99808L14.6302 6.10833L10.3181 9.37749L11.8851 14.5569L7.44344 11.4661L3.00178 14.5569L4.56874 9.37749L0.256687 6.10833L5.66678 5.99808L7.44344 0.886841Z"></path></svg></span></div><div class="reivew-time">'+fromNow(newArray[key].review.dateCreated)+'</div></div><ul class="image-list '+(newArray[key].review.imagesFileName ? '':'d-none')+'"><li><img src="https://cdn.stamped.io/uploads/photos/'+newArray[key].review.imagesFileName+'"></li></ul><h5 class="message-title">'+newArray[key].review.title+' </h5><p class="message">'+newArray[key].review.body+'</p></div></div></div>'
  }
  $("#section-product-rating-and-reivew-mobile .container").append(html);
  $("#section-product-rating-and-reivew .container").append(html);
  for(var i=1;  i <= (reviewsData.length / pagination_limit); i++){
    pagination += '<div class="page '+(page == i ? 'active':'')+'" onclick=showReviews('+i+')>'+i+'</div>'
  }
  // $("#section-product-rating-and-reivew-mobile .container").append('<div class="pagination-container"><div class="pagination"><div class="move-prev disabled"><svg width="49" height="49" viewBox="0 0 49 49" stroke="#1A1A1A" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35.9514 24.6326L15.9514 24.6326" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M22.9514 15.6326C20.4514 20.6326 17.4514 23.1326 13.9514 24.6326C17.4514 26.1326 20.4514 28.6326 22.9514 33.6326" stroke-width="1.5" stroke-linecap="round"></path></svg></div><div class="page-list">'+pagination+'</div><div class="move-next"><svg width="49" height="49" viewBox="0 0 49 49" fill="none" stroke="#1A1A1A" xmlns="http://www.w3.org/2000/svg"><path d="M13.503 24.6326L33.503 24.6326" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M26.503 15.6326C29.003 20.6326 32.003 23.1326 35.503 24.6326C32.003 26.1326 29.003 28.6326 26.503 33.6326" stroke-width="1.5" stroke-linecap="round"></path></svg></div></div></div>');
  // $("#section-product-rating-and-reivew .container").append('<div class="pagination-container"><div class="pagination"><div class="move-prev disabled"><svg width="49" height="49" viewBox="0 0 49 49" stroke="#1A1A1A" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35.9514 24.6326L15.9514 24.6326" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M22.9514 15.6326C20.4514 20.6326 17.4514 23.1326 13.9514 24.6326C17.4514 26.1326 20.4514 28.6326 22.9514 33.6326" stroke-width="1.5" stroke-linecap="round"></path></svg></div><div class="page-list">'+pagination+'</div><div class="move-next"><svg width="49" height="49" viewBox="0 0 49 49" fill="none" stroke="#1A1A1A" xmlns="http://www.w3.org/2000/svg"><path d="M13.503 24.6326L33.503 24.6326" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M26.503 15.6326C29.003 20.6326 32.003 23.1326 35.503 24.6326C32.003 26.1326 29.003 28.6326 26.503 33.6326" stroke-width="1.5" stroke-linecap="round"></path></svg></div></div></div>');
}

$(".is-sw__color").click(function(){
  var color = $(this).attr("data-value").toLowerCase();
   var screenWidth = $(window).width();
    // Check if on mobile (screen width less than 768px)
    if (screenWidth < 768) {
      $('html, body').animate({scrollTop: '0'}, 300);
    }
  // setTimeout(() => {
  //   $(".t4s-carousel__nav-scroller").find('[data-grpvl="'+color+'"]').eq(0).find(".t4s-carousel__nav-inner").trigger("click")
  // },200);
});

$(window).scroll(function(){
    if (window.scrollY > 3700){
       $("#go-to-top").removeClass("d-none");
    }else{
       $("#go-to-top").addClass("d-none");
    }
}); 

